<!-- <h1>{{title}}</h1> -->
<!-- singup-start -->
<div [hidden]="loading==true">
    <router-outlet></router-outlet>
</div>
<div [hidden]="loading==false" class="loader">
    <!-- <ng-lottie (domLoaded)="domLoaded()" width="350px" height="500px" [options]="options"></ng-lottie> -->
    <img *ngIf="appName == 'filmbox'" src="../assets/{{appName}}/loadersvg.svg" alt="You are moments away from great content" />
    <img *ngIf="appName == 'film1'" src="../assets/{{appName}}/loadersvg.svg" width="80px; height:80px" alt="You are moments away from great content"/>
</div>